import { Component, inject, viewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { AdaaHelper } from "../../../core/utils";
import { ConfirmationModalComponent, DataTableComponent, FloatActionComponent } from "../../../shared/components";
import { genericFloatButtons } from "../../../shared/components/general/float-action";
import { Constants } from "../../../shared/constants/constants";
import { Language } from "../../../shared/constants/enums";
import { IntegrityRuleSet, TableButtonClicked } from "../../../shared/models";
import { AppService, SystemLayoutService } from "../../../shared/services";
import { IntegrityApiService } from "../../../shared/services/integrity-api-service";

@Component({
  selector: "adaa-integrity-rules-list",
  imports: [DataTableComponent, TranslatePipe, FloatActionComponent],
  templateUrl: "./integrity-rules-list.html",
  styleUrl: "./integrity-rules-list.scss",
})
export class IntegrityRulesListComponent {
  private _router = inject(Router);
  private _systemLayoutService = inject(SystemLayoutService);
  private _modalService = inject(NgbModal);
  private _appService = inject(AppService);
  private _integrityApiService = inject(IntegrityApiService);
  private _toastrService = inject(ToastrService);
  private _translateService = inject(TranslateService);

  readonly #untilDestroy = AdaaHelper.untilDestroyed();

  adaaDataTable = viewChild.required<DataTableComponent>("adaaDataTable");
  Constants = Constants;
  readonly #floatActions = genericFloatButtons();

  public ngOnInit() {
    this._floatActions();
    this._systemLayoutService.hasActiveEntityChanged$.pipe(this.#untilDestroy()).subscribe({
      next: () => {
        this._router.navigateByUrl(`/console`);
      },
    });
  }

  private _floatActions() {
    this.#floatActions([
      {
        key: "print",
        data: undefined,
      },
      {
        key: "helpdesk",
        data: {
          url: "/helpdesk/create",
        },
      },
    ]);
  }

  public addNewRule() {
    this._router.navigateByUrl(`/console/rules/create`);
  }

  public getAction(event: TableButtonClicked) {
    const id = event.data.id;
    switch (event.event) {
      case "edit":
        this._router.navigateByUrl(`/console/rules/edit/${id}`);
        break;

      case "delete":
        this._deleteRuleSet(id);
        break;

      default:
        break;
    }
  }

  private _deleteRuleSet(data: IntegrityRuleSet) {
    const modal = this._modalService.open(ConfirmationModalComponent, {
      centered: true,
      size: "md",
      modalDialogClass: this._appService.language() === Language.Arabic ? "modal-rtl" : "modal-ltr",
    });

    modal.componentInstance.header = "rules_management.delete_yes_no_title";
    modal.componentInstance.title = "rules_management.delete_yes_no_information";

    modal.result.then((e) => {
      if (e) {
        this._integrityApiService.deleteRuleSet(data.id).subscribe({
          next: (response) => {
            if (response.inError) return;
            this._toastrService.success(this._translateService.instant("notification.success.remove"));
            this.adaaDataTable().loadTableData();
          },
        });
      }
    });
  }
}
